let applyPhoneMaskMixin = {
    methods: {
        applyPhoneMask(value) {
            if (!value) {
                return '';
            }

            const digits = String(value).replace(/\D/g, '').slice(-10);

            if (digits.length !== 10) {
                return String(value);
            }

            let mask = '+38 (###) ###-####';
            let i= 0;
            return mask.replace(/#/g, () => digits[i++]);
        },
        getPhoneHref(value) {
            const digits = value ? String(value).replace(/\D/g, '') : '';

            if (!digits) {
                return '';
            }

            const phone = digits.slice(-10);

            return phone.length === 10 ? `tel:+38${phone}` : '';
        },
    }
}

export default applyPhoneMaskMixin;
